import React, { useState } from "react";
import { m, AnimatePresence } from "framer-motion";
import ChevronDownLight from "./icons/chevron-down-light";
export default function FaqDropdown({ children, initial = false, title }) {
  const [open, setOpen] = useState(initial ?? false);
  return (
    <div
      className={`bg-[#f5f5f5] rounded-[10px] last:mb-0 md:mb-8 mb-4 md:px-8 px-4 md:py-4 py-3 w-full group flex flex-col z-0 overflow-hidden cursor-pointer`}
    >
      <div
        className="flex flex-row justify-between items-center md:py-5 py-2 h-auto w-full relative"
        onClick={() => setOpen(!open)}
      >
        <p
          className={`font-medium transition-all duration-300 ease text-black lg:text-lg md:text-base text-sm max-w-[90%] md:max-w-full`}
        >
          {title}
        </p>

        <ChevronDownLight
          className={`shrink-0 w-3 transition-all text-[#000000] duration-300 ease transform ${
            !open ? "rotate-180" : "rotate-0"
          } relative`}
        />
      </div>
      <AnimatePresence initial={false}>
        {open && (
          <m.div
            key="content"
            initial="collapsed"
            animate="open"
            exit="collapsed"
            variants={{
              open: { height: "auto", opacity: 1 },
              collapsed: { height: "0px", opacity: 0 },
            }}
            transition={{ duration: 0.6, ease: [0.04, 0.62, 0.23, 0.98] }}
          >
            <m.div
              variants={{ collapsed: { opacity: 0.8 }, open: { opacity: 1 } }}
              transition={{ duration: 0.3 }}
              className="text-black/80 border-t-[1px] border-[#707070]/20  w-full pt-4 lg:text-lg md:text-base text-sm [&>p>a]:text-blue [&>p>a]:underline [&>p>a]:hover:text-black"
            >
              {children}
            </m.div>
          </m.div>
        )}
      </AnimatePresence>
    </div>
  );
}
